import { ReactNode, RefObject } from 'react';

import { CloseButton } from '../../../../components/Clickables/Controls/CloseButton/CloseButton';
import { ControlLikeVariant } from '../../../../components/Clickables/variants';
import { useExplore } from '../../context/ExploreContext';

interface IProps {
  children: ReactNode;
  className?: string;
  withCloseButton?: boolean;
  closeButtonClassName?: string;
  variant?: ControlLikeVariant;
  headerContent?: ReactNode;
  fullWidthHeaderContent?: ReactNode;
  footerContent?: ReactNode;
  fullHeight?: boolean;
  drawerRef?: RefObject<HTMLDivElement | null>;
  contentId?: string;
}

export const MapDrawerLayout = ({
  children,
  headerContent = null, // When headerContent is provided the header will be sticky
  fullWidthHeaderContent = null, // For posting a full width button WITH header content
  footerContent = null,
  className = '',
  withCloseButton = true,
  closeButtonClassName = '',
  variant,
  fullHeight = true,
  drawerRef,
  contentId,
}: IProps) => {
  const { saveParamsInUrl } = useExplore();

  const handleDrawerClose = (): void => {
    saveParamsInUrl({ drawerView: undefined, drawerViewId: undefined });
  };

  return (
    <div
      className={`${className} ${
        fullHeight ? 'min-h-full' : ''
      } bg-lake-fog scrollbar-none grid p-4 ${
        headerContent ? 'h-full grid-rows-[max-content_1fr] overflow-hidden' : ''
      }`}
      data-testid="MapDrawerLayout"
    >
      {headerContent ? (
        <div className="z-mid col-start-1 row-start-1 mb-auto">
          <div className="flex items-start">
            {headerContent}
            {withCloseButton && (
              <CloseButton
                className={`ml-auto ${closeButtonClassName}`}
                variant={variant ?? `controlLakeFogBg`}
                onClick={handleDrawerClose}
              />
            )}
          </div>
          {fullWidthHeaderContent && fullWidthHeaderContent}
        </div>
      ) : (
        withCloseButton && (
          <CloseButton
            className={`z-high col-start-1 row-start-1 mb-auto ml-auto ${closeButtonClassName}`}
            variant={variant ?? `controlLakeFogBg`}
            onClick={handleDrawerClose}
          />
        )
      )}

      <div
        ref={drawerRef}
        id={contentId}
        className={`col-start-1 ${
          headerContent ? 'scrollbar-none row-start-2 h-full overflow-y-scroll' : 'row-start-1'
        }`}
      >
        {children}
      </div>
      {footerContent && (
        <div className="z-mid bg-lake-fog col-start-1 row-start-3 mt-auto flex w-full items-start">
          {footerContent}
        </div>
      )}
    </div>
  );
};
